export enum LANGUAGES {
  fr = 'fr',
  fr_FR = 'fr-FR',
  en_US = 'en-US',
  en = 'en',
}

export enum DOCUMENT_VERSION_TYPE {
  APPLICABLES = 'applicables',
  NEXT_APPLICABLES = 'nextApplicables',
}

export enum RESOURCES_KEYS {
  // Errors
  API_ERROR_AN_ERROR_HAS_OCCURRED = 'AN_ERROR_HAS_OCCURRED',
  API_ERROR_VERSION_NOT_FOUND = 'VERSION_NOT_FOUND',
  API_ERROR_FILE_NOT_FOUND = 'FILE_NOT_FOUND',
  API_ERROR_USER_NOT_FOUND = 'USER_NOT_FOUND',
  API_ERROR_USER_DELETED = 'USER_DELETED',
  API_ERROR_USER_NOT_ENABLED = 'USER_NOT_ENABLED',
  API_ERROR_DISPATCH_NOT_FOUND = 'DISPATCH_NOT_FOUND',
  API_ERROR_WRONG_DATE_FORMAT = 'WRONG_DATE_FORMAT',
  API_ERROR_DOCUMENT_NOT_FOUND = 'DOCUMENT_NOT_FOUND',

  // End Errors
  APPLICABLES = 'applicables',
  NEXT_APPLICABLES = 'nextApplicables',
  READ_DOCUMENT = 'readDocument',
  CLOSE_VIEWER_MODAL = 'closeViewerModal',
  FROM_DATE = 'fromDate',
  TO_DATE = 'toDate',
  QUOTA_LIMIT = 'qutoaLimit',
  USED = 'used',
  NEW = 'new',
  CANCEL = 'cancel',
  ADD = 'add',
  SEND = 'send',
  ACK_TITLE = 'ackTitle',
  ACK_CONTENT_TEXT = 'ackContentText',
  ACK_CHECKBOX_LABEL = 'ackCheckboxLabel',
  ACK_VALIDATION_MESSAGE = 'ackValidationMessage',
  ENABLE_PDF_THUMBNAILS = 'enablePdfPreview',
  REFRESH_PAGE = 'refreshPage',
  LOAD_MORE = 'loadMore',
  DOCUMENT_TO_VALIDATE = 'documentToValid',
  DOCUMENT_DISPAY_MANAGEMENT = 'documentDispayManagement',
  ORDER_DOCUMENTS_BY = 'orderDocumentsBy',
  FILTER_DOCUMENTS = 'filterDocuments',
  TITLE = 'title',
  CODE_ACTIVITY_AND_SERIAL_NUM_AND_LETTER = 'codeActivityAndSerialNumAndLetter',
  VERSION = 'version',
  START_DATE = 'startDate',
  ACK_DATE = 'ackDate',
  DOCUMENT_DETAILS = 'documentDetails',
  FULL_TITLE = 'fullTitle',
  END_DATE = 'endDate',
  FIELD_REQUIRED = 'fieldRequired',
  ERROR_BOUNDARY_TITLE = 'errorBoundaryTitle',
  FAVORITES_EMPTY = 'favoritesEmpty',  
  ACKNOWLEDGEMENT_EMPTY = 'acknowledmentEmpty',
  PLEASE_CONTACT_SUPPORT_TEAM = 'pleaseContactSupportTeam',
  THE_LAST_10_DOCUMENTS_READ = 'lastRead',
  THE_10_DOCUMENTS_MOST_READ = 'mostRead',
  THE_LAST_10_NEW_APPLICABLES_DOCUMENTS = 'lastAddedApplicables',
  THE_LAST_10_NEW_NEXT_APPLICABLES_DOCUMENTS = 'lastAddedNextApplicables',
  RESET_DATABASE = 'resetDatabase',
  LOAD_ALL_VERSIONS_API_REQUEST = 'forceVersionsApiRequest',
  MENU_HOME = 'MenuHome',
  MENU_CATEGORIES = 'MenuCategories',
  MENU_FAVORITES = 'MenuFavorites',
  MENU_ACKNOWLEDGEMENT = 'MenuAcknowledgement',
  MENU_SETTINGS = 'MenuSettings',
  MENU_LOGOUT = 'MenuLogout',
  CLOSE = "close",
  DIALOG_DOWNLOADING_DOCS_DONE = "dialogDownloadingDocsDone",
  DIALOG_NO_SLEEP_MESSAGE = "dialogNoSleepMessage",
  YES = "yes",
  NO = "no",
  IOS_PROMPT_ADD_TO_HOME_SCREEN = "addToHomeScreen",
  IOS_PROMPT_ADD_TO_HOME_SCREEN_MESSAGE = "addToHomeScreenMessage",
  IOS_PROMPT_PRESS_SHARE_BUTTON = "pressShareButton",
  IOS_PROMPT_PRESS_ADD_TO_HOME_SCREEN_BUTTON = "pressAddToHomeScreenButton",
  RELOAD_DOC = "ReloadDocument",
  NOTIFICATION_ACTIVATE = "ActivateNotification",
  NOTIFICATION_BLOCKED = "NotificationBlocked",
  PDF_ADD_A_NOTE = "pdfAddANoteTooltip",
  PDF_NOTE_TITLE = "pdfNoteTilte",
  PDF_NO_NOTE = "pdfNoteNoNote",
  PDF_ADD_A_PAGE_NOTE = "pdfNoteAddNotePage",
  PDF_ADD_A_PAGE_NOTE_DESCRIPTION = "pdfNoteAddNotePageDescription",
  GLOBALSEARCH = "globalSearch",
  ORDER_CATEGORIES = 'OrderCategories'
}

export const resources = {
  en: {
    translation: {
      [RESOURCES_KEYS.APPLICABLES]: 'Applicables',
      [RESOURCES_KEYS.NEXT_APPLICABLES]: 'Applicables soon',
      [RESOURCES_KEYS.READ_DOCUMENT]: 'Read the document',
      [RESOURCES_KEYS.CLOSE_VIEWER_MODAL]: 'Close',
      [RESOURCES_KEYS.FROM_DATE]: 'From',
      [RESOURCES_KEYS.TO_DATE]: ' to',
      [RESOURCES_KEYS.QUOTA_LIMIT]: 'Save up to',
      [RESOURCES_KEYS.USED]: 'Used',
      [RESOURCES_KEYS.NEW]: 'New',
      [RESOURCES_KEYS.ACK_TITLE]: 'Confirmation of receipt',
      [RESOURCES_KEYS.ACK_CONTENT_TEXT]: 'Please confirm reception of the following document',
      [RESOURCES_KEYS.ACK_CHECKBOX_LABEL]: 'This is the sentence for acknowledgment',
      [RESOURCES_KEYS.CANCEL]: 'Cancel',
      [RESOURCES_KEYS.SEND]: 'Send',
      [RESOURCES_KEYS.ACK_VALIDATION_MESSAGE]: 'Acknowledgment of receipt of the {{documentName}} sent',
      [RESOURCES_KEYS.ENABLE_PDF_THUMBNAILS]: 'Enable Thumbnails',
      [RESOURCES_KEYS.REFRESH_PAGE]: 'Refresh',
      [RESOURCES_KEYS.LOAD_MORE]: 'Load more documents',
      [RESOURCES_KEYS.DOCUMENT_TO_VALIDATE]: 'Document to validate',
      [RESOURCES_KEYS.DOCUMENT_DISPAY_MANAGEMENT]: 'Document display management',
      [RESOURCES_KEYS.ORDER_DOCUMENTS_BY]: 'Order documents by:',
      [RESOURCES_KEYS.FILTER_DOCUMENTS]: 'Filter documents :',
      [RESOURCES_KEYS.TITLE]: 'Title',
      [RESOURCES_KEYS.VERSION]: 'Version',
      [RESOURCES_KEYS.CODE_ACTIVITY_AND_SERIAL_NUM_AND_LETTER]: 'Activity code / Serial number / Letter',
      [RESOURCES_KEYS.START_DATE]: 'Start date',
      [RESOURCES_KEYS.END_DATE]: 'End date',
      [RESOURCES_KEYS.ACK_DATE]: 'Acknowledgment date',
      [RESOURCES_KEYS.DOCUMENT_DETAILS]: 'Document details',
      [RESOURCES_KEYS.FULL_TITLE]: 'Full title',
      [RESOURCES_KEYS.FIELD_REQUIRED]: 'Field required',
      [RESOURCES_KEYS.ERROR_BOUNDARY_TITLE]: 'An error occurred on the {{page}} page',
      [RESOURCES_KEYS.FAVORITES_EMPTY]: 'No bookmark',
      [RESOURCES_KEYS.ACKNOWLEDGEMENT_EMPTY]: 'No acknowledment',
      [RESOURCES_KEYS.PLEASE_CONTACT_SUPPORT_TEAM]: 'Please contact the support team',
      [RESOURCES_KEYS.THE_LAST_10_DOCUMENTS_READ]: 'Your last 10 documents read',
      [RESOURCES_KEYS.THE_10_DOCUMENTS_MOST_READ]: ' Your most read documents',
      [RESOURCES_KEYS.THE_LAST_10_NEW_APPLICABLES_DOCUMENTS]: 'Last applicable versions added',
      [RESOURCES_KEYS.THE_LAST_10_NEW_NEXT_APPLICABLES_DOCUMENTS]: 'Last soon applicable versions added',
      [RESOURCES_KEYS.RESET_DATABASE]: 'Reset the database',
      [RESOURCES_KEYS.LOAD_ALL_VERSIONS_API_REQUEST]: 'Load all versions',
      [RESOURCES_KEYS.MENU_HOME]: 'Home',
      [RESOURCES_KEYS.MENU_CATEGORIES]: 'Categories',
      [RESOURCES_KEYS.MENU_FAVORITES]: 'Starred',
      [RESOURCES_KEYS.MENU_ACKNOWLEDGEMENT]: 'Acknowledgement',
      [RESOURCES_KEYS.MENU_SETTINGS]: 'Settings',
      [RESOURCES_KEYS.MENU_LOGOUT]: 'Logout',
      [RESOURCES_KEYS.CLOSE]: 'Close',
      [RESOURCES_KEYS.API_ERROR_AN_ERROR_HAS_OCCURRED]: 'An error has occurred',
      [RESOURCES_KEYS.API_ERROR_VERSION_NOT_FOUND]: 'Version not found',
      [RESOURCES_KEYS.API_ERROR_FILE_NOT_FOUND]: 'The file not found',
      [RESOURCES_KEYS.API_ERROR_USER_NOT_FOUND]: 'The user not found',
      [RESOURCES_KEYS.API_ERROR_USER_DELETED]: 'The user is deleted',
      [RESOURCES_KEYS.API_ERROR_USER_NOT_ENABLED]: 'The user not enabled',
      [RESOURCES_KEYS.API_ERROR_DISPATCH_NOT_FOUND]: 'The dispatch not found',
      [RESOURCES_KEYS.API_ERROR_WRONG_DATE_FORMAT]: 'Wrong date format',
      [RESOURCES_KEYS.API_ERROR_DOCUMENT_NOT_FOUND]: 'Document not found',
      [RESOURCES_KEYS.DIALOG_DOWNLOADING_DOCS_DONE]: 'Download of documents completed',
      [RESOURCES_KEYS.DIALOG_NO_SLEEP_MESSAGE]: 'Would you like to block the device from sleeping while downloading documents?',
      [RESOURCES_KEYS.YES]: 'Yes',
      [RESOURCES_KEYS.NO]: 'No',
      [RESOURCES_KEYS.IOS_PROMPT_ADD_TO_HOME_SCREEN]: 'Add to Home Screen',
      [RESOURCES_KEYS.IOS_PROMPT_ADD_TO_HOME_SCREEN_MESSAGE]: 'To add the application to your home screen to use it in fullscreen and while offline.',
      [RESOURCES_KEYS.IOS_PROMPT_PRESS_SHARE_BUTTON]: "1) Press the 'Share' button on the menu bar at the top.",
      [RESOURCES_KEYS.IOS_PROMPT_PRESS_ADD_TO_HOME_SCREEN_BUTTON]: "2) Press 'Add to Home Screen'.",
      [RESOURCES_KEYS.RELOAD_DOC]: "Reset the document",
      [RESOURCES_KEYS.NOTIFICATION_ACTIVATE]: "Activate Notifications",
      [RESOURCES_KEYS.NOTIFICATION_BLOCKED]: "Notifications Blocked",
      [RESOURCES_KEYS.PDF_ADD_A_NOTE]: "Add a note.",
      [RESOURCES_KEYS.ADD]: "Add",
      [RESOURCES_KEYS.PDF_NOTE_TITLE]: "Current notes",
      [RESOURCES_KEYS.PDF_NO_NOTE]: "There is no note yet.",
      [RESOURCES_KEYS.PDF_ADD_A_PAGE_NOTE]: "Add a page note",
      [RESOURCES_KEYS.PDF_ADD_A_PAGE_NOTE_DESCRIPTION]:"Add a note to the current page",
      [RESOURCES_KEYS.GLOBALSEARCH]:"Global search",
      [RESOURCES_KEYS.ORDER_CATEGORIES]:"Order categories",
    },
  },
  fr: {
    translation: {
      [RESOURCES_KEYS.APPLICABLES]: 'Applicables',
      [RESOURCES_KEYS.NEXT_APPLICABLES]: 'Prochainement Applicables',
      [RESOURCES_KEYS.READ_DOCUMENT]: 'Lire le document',
      [RESOURCES_KEYS.CLOSE_VIEWER_MODAL]: 'Fermer',
      [RESOURCES_KEYS.FROM_DATE]: 'Du',
      [RESOURCES_KEYS.TO_DATE]: ' au',
      [RESOURCES_KEYS.USED]: 'Utilisé',
      [RESOURCES_KEYS.QUOTA_LIMIT]: "Enregistrez jusqu'à",
      [RESOURCES_KEYS.NEW]: 'Nouveau',
      [RESOURCES_KEYS.ACK_TITLE]: 'Confirmation de réception',
      [RESOURCES_KEYS.ACK_CONTENT_TEXT]: 'Veuillez confirmer la réception du document suivant',
      [RESOURCES_KEYS.ACK_CHECKBOX_LABEL]: 'Je confirme avoir reçu ce document',
      [RESOURCES_KEYS.CANCEL]: 'Annuler',
      [RESOURCES_KEYS.SEND]: 'Envoyer',
      [RESOURCES_KEYS.ACK_VALIDATION_MESSAGE]: 'Accusé de reception du {{documentName}} envoyé',
      [RESOURCES_KEYS.ENABLE_PDF_THUMBNAILS]: 'Activer la préview',
      [RESOURCES_KEYS.REFRESH_PAGE]: 'Actualiser',
      [RESOURCES_KEYS.LOAD_MORE]: 'Charger plus de documents',
      [RESOURCES_KEYS.DOCUMENT_TO_VALIDATE]: 'Document à valider',
      [RESOURCES_KEYS.DOCUMENT_DISPAY_MANAGEMENT]: 'Gestion affichage des documents',
      [RESOURCES_KEYS.ORDER_DOCUMENTS_BY]: 'Trier les documents par :',
      [RESOURCES_KEYS.FILTER_DOCUMENTS]: 'Filtrer les documents :',
      [RESOURCES_KEYS.TITLE]: 'Titre',
      [RESOURCES_KEYS.CODE_ACTIVITY_AND_SERIAL_NUM_AND_LETTER]: 'Code activité / Numéro de série / Lettre',
      [RESOURCES_KEYS.VERSION]: 'Version',
      [RESOURCES_KEYS.START_DATE]: "Date d'application",
      [RESOURCES_KEYS.END_DATE]: "Date de fin d'application",
      [RESOURCES_KEYS.ACK_DATE]: "Date d'acquittement",
      [RESOURCES_KEYS.DOCUMENT_DETAILS]: 'Informations du document',
      [RESOURCES_KEYS.FULL_TITLE]: 'Titre complet',
      [RESOURCES_KEYS.FIELD_REQUIRED]: 'Champ obligatoire',
      [RESOURCES_KEYS.ERROR_BOUNDARY_TITLE]: 'Une erreur est survenue sur la page {{page}}',
      [RESOURCES_KEYS.PLEASE_CONTACT_SUPPORT_TEAM]: "Merci de vous rapprochez de l'équipe support",
      [RESOURCES_KEYS.FAVORITES_EMPTY]: 'Aucun Favori',
      [RESOURCES_KEYS.ACKNOWLEDGEMENT_EMPTY]: 'Aucun document à acquitter',
      [RESOURCES_KEYS.THE_LAST_10_DOCUMENTS_READ]: 'Vos 10 derniers documents lus',
      [RESOURCES_KEYS.THE_10_DOCUMENTS_MOST_READ]: 'Vos documents les plus lus',
      [RESOURCES_KEYS.THE_LAST_10_NEW_APPLICABLES_DOCUMENTS]: 'Dernières versions applicables ajoutées',
      [RESOURCES_KEYS.THE_LAST_10_NEW_NEXT_APPLICABLES_DOCUMENTS]: 'Dernières versions prochainement applicables ajoutées',
      [RESOURCES_KEYS.RESET_DATABASE]: 'Vider la base de données',
      [RESOURCES_KEYS.LOAD_ALL_VERSIONS_API_REQUEST]: 'Forcer le chargement de toutes les versions',
      [RESOURCES_KEYS.MENU_HOME]: 'Accueil',
      [RESOURCES_KEYS.MENU_CATEGORIES]: 'Catégories',
      [RESOURCES_KEYS.MENU_FAVORITES]: 'Favoris',
      [RESOURCES_KEYS.MENU_ACKNOWLEDGEMENT]: 'Acquittement',
      [RESOURCES_KEYS.MENU_SETTINGS]: 'Paramètres',
      [RESOURCES_KEYS.MENU_LOGOUT]: 'Déconnexion',
      [RESOURCES_KEYS.CLOSE]: 'Fermer',
      [RESOURCES_KEYS.API_ERROR_AN_ERROR_HAS_OCCURRED]: 'une erreur est survenue',
      [RESOURCES_KEYS.API_ERROR_VERSION_NOT_FOUND]: "La version n'existe pas",
      [RESOURCES_KEYS.API_ERROR_FILE_NOT_FOUND]: "Le fichier n'est pas trouvé",
      [RESOURCES_KEYS.API_ERROR_USER_NOT_FOUND]: "L'utilisateur n'est pas trouvé",
      [RESOURCES_KEYS.API_ERROR_USER_DELETED]: "L'utilisateur est supprimé",
      [RESOURCES_KEYS.API_ERROR_USER_NOT_ENABLED]: "L'utilisateur est désactivé",
      [RESOURCES_KEYS.API_ERROR_DISPATCH_NOT_FOUND]: "L'envoi n'existe pas",
      [RESOURCES_KEYS.API_ERROR_WRONG_DATE_FORMAT]: 'Le format de la date est invalide',
      [RESOURCES_KEYS.API_ERROR_DOCUMENT_NOT_FOUND]: "Le document n'existe pas",
      [RESOURCES_KEYS.DIALOG_DOWNLOADING_DOCS_DONE]: 'Le téléchargement des documents a terminé',
      [RESOURCES_KEYS.DIALOG_NO_SLEEP_MESSAGE]: "Souhaitez vous bloquer la mise en veille de l'appareil pendant le téléchargement des documents?",
      [RESOURCES_KEYS.YES]: 'Oui',
      [RESOURCES_KEYS.NO]: 'Non',
      [RESOURCES_KEYS.IOS_PROMPT_ADD_TO_HOME_SCREEN]: "Ajouter sur l'écran d'accueil",
      [RESOURCES_KEYS.IOS_PROMPT_ADD_TO_HOME_SCREEN_MESSAGE]: "Pour ajoutez l'application à votre écran d'accueil pour l'utiliser en plein écran et hors ligne.",
      [RESOURCES_KEYS.IOS_PROMPT_PRESS_SHARE_BUTTON]: "1) Appuyer sur le bouton 'Partager' dans la barre de menu en haut.",
      [RESOURCES_KEYS.IOS_PROMPT_PRESS_ADD_TO_HOME_SCREEN_BUTTON]: "2) Appuyer sur le bouton 'Add to Home Screen'.",
      [RESOURCES_KEYS.RELOAD_DOC]: "Recharger le document",
      [RESOURCES_KEYS.NOTIFICATION_ACTIVATE]: "Activer Notifications",
      [RESOURCES_KEYS.NOTIFICATION_BLOCKED]: "Notifications Bloquées",
      [RESOURCES_KEYS.PDF_ADD_A_NOTE]: "Ajouter une note.",
      [RESOURCES_KEYS.ADD]: "Ajouter",
      [RESOURCES_KEYS.PDF_NOTE_TITLE]: "Notes actuelles",
      [RESOURCES_KEYS.PDF_NO_NOTE]: "Il n'y a pas encore de note.",
      [RESOURCES_KEYS.PDF_ADD_A_PAGE_NOTE]: "Ajouter une note à la page",
      [RESOURCES_KEYS.PDF_ADD_A_PAGE_NOTE_DESCRIPTION]:"Ajouter une note à la page courante",
      [RESOURCES_KEYS.GLOBALSEARCH]:"Recherche globale",
      [RESOURCES_KEYS.ORDER_CATEGORIES]:"Ordonner les catégories",
    },
  },
};
